import React, { useState, useEffect } from "react";
import CleanLayout from "../../layouts/CleanLayout";
import "../login/login.css";

const API_URL =
  process.env.REACT_APP_API_URL || "http://localhost:3004/graphql";

const NewPassPage: React.FC = () => {
  const [token, setToken] = useState<string | null>(null);
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const t = params.get("token");
    if (!t) {
      setError("Enlace inválido. Solicita un nuevo correo de recuperación.");
    }
    setToken(t);
  }, []);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (password.length < 6) {
      setError("La contraseña debe tener al menos 6 caracteres.");
      return;
    }
    if (password !== confirmPassword) {
      setError("Las contraseñas no coinciden.");
      return;
    }

    setLoading(true);
    try {
      const res = await fetch(API_URL, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          query: `mutation ResetPassword($token: String!, $password: String!) {
            resetPassword(token: $token, password: $password)
          }`,
          variables: { token, password },
        }),
      });
      const json = await res.json();
      if (json.errors) {
        setError(json.errors[0].message);
      } else {
        setSuccess(true);
      }
    } catch (err) {
      console.error("resetPassword error:", err);
      setError("Error de conexión. Intenta de nuevo.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <CleanLayout title="Foo | Nueva Contraseña">
      <div className="container" style={{ marginTop: "4rem", minHeight: "80vh" }}>
        <div className="row justify-content-center">
          <div className="col-11 col-sm-8 col-md-5 col-lg-4">
            <div
              style={{
                background: "#fff",
                borderRadius: "16px",
                padding: "2.5rem 2rem",
                boxShadow: "0 4px 24px rgba(0,0,0,0.08)",
              }}
            >
              <div className="text-center mb-4">
                <a href="/">
                  <img
                    src="/img/logo_svg.png"
                    alt="Foo Logo"
                    style={{ maxWidth: "140px" }}
                  />
                </a>
              </div>

              {success ? (
                <div className="text-center">
                  <div
                    style={{
                      width: "64px",
                      height: "64px",
                      borderRadius: "50%",
                      background: "#48BB78",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      margin: "0 auto 1.5rem",
                    }}
                  >
                    <i
                      className="fas fa-check"
                      style={{ color: "#fff", fontSize: "28px" }}
                    ></i>
                  </div>
                  <h5 style={{ fontWeight: 600, marginBottom: "0.5rem" }}>
                    Contraseña Actualizada
                  </h5>
                  <p
                    className="text-muted"
                    style={{ fontSize: "14px", marginBottom: "1.5rem" }}
                  >
                    Ya puedes iniciar sesión en la app con tu nueva contraseña.
                  </p>
                  <a
                    href="/"
                    className="btn btn-block"
                    style={{
                      background: "#292929",
                      color: "#fff",
                      padding: "0.75rem",
                      borderRadius: "10px",
                      fontWeight: 600,
                    }}
                  >
                    Ir al Inicio
                  </a>
                </div>
              ) : (
                <>
                  <h5
                    className="text-center"
                    style={{ fontWeight: 600, marginBottom: "0.25rem" }}
                  >
                    Nueva Contraseña
                  </h5>
                  <p
                    className="text-center text-muted"
                    style={{ fontSize: "14px", marginBottom: "1.5rem" }}
                  >
                    Ingresa tu nueva contraseña para continuar.
                  </p>

                  {error && (
                    <div
                      style={{
                        background: "#FFF5F5",
                        border: "1px solid #FC8181",
                        borderRadius: "10px",
                        padding: "0.75rem 1rem",
                        marginBottom: "1rem",
                        fontSize: "14px",
                        color: "#C53030",
                      }}
                    >
                      <i className="fas fa-exclamation-circle"></i> {error}
                    </div>
                  )}

                  <form onSubmit={handleSubmit}>
                    <div style={{ marginBottom: "1rem" }}>
                      <label
                        htmlFor="password"
                        style={{
                          display: "block",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#555",
                          marginBottom: "6px",
                        }}
                      >
                        Nueva Contraseña
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="password"
                        placeholder="Mínimo 6 caracteres"
                        required
                        minLength={6}
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="new-password"
                        autoFocus
                        disabled={!token}
                        style={{
                          borderRadius: "10px",
                          padding: "0.75rem 1rem",
                          border: "1px solid #ddd",
                          fontSize: "15px",
                        }}
                      />
                    </div>
                    <div style={{ marginBottom: "1.5rem" }}>
                      <label
                        htmlFor="confirmPassword"
                        style={{
                          display: "block",
                          fontSize: "13px",
                          fontWeight: 600,
                          color: "#555",
                          marginBottom: "6px",
                        }}
                      >
                        Confirmar Contraseña
                      </label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        placeholder="Repite tu contraseña"
                        required
                        minLength={6}
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                        autoComplete="new-password"
                        disabled={!token}
                        style={{
                          borderRadius: "10px",
                          padding: "0.75rem 1rem",
                          border: "1px solid #ddd",
                          fontSize: "15px",
                        }}
                      />
                    </div>
                    <button
                      type="submit"
                      className="btn btn-block"
                      disabled={loading || !token}
                      style={{
                        background: "#FFBB28",
                        color: "#292929",
                        padding: "0.75rem",
                        borderRadius: "10px",
                        fontWeight: 700,
                        fontSize: "16px",
                        border: "none",
                        opacity: loading || !token ? 0.6 : 1,
                      }}
                    >
                      {loading ? (
                        <>
                          <i className="fas fa-spinner fa-spin"></i> Guardando...
                        </>
                      ) : (
                        "Cambiar Contraseña"
                      )}
                    </button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
    </CleanLayout>
  );
};

export default NewPassPage;
